import { get, post } from "../baseRequest";
import { ICmsItem } from "../dto/cms/ICmsItem";

export const fetchCmsDataByFilter = async (type: string) => {
  const res = await get(`/odata/Cms?$filter=Type eq '${type}'`);

  return res.value[0];
};

export const fetchAllCms = async (name?: string) => {
  if (name) {
    const quoteCount = (name.match(/'/g) || []).length;
    if (quoteCount % 2 !== 0) {
      name = name.replace(/'/g, "''");
    }
  }

  const sanitizedName = name ? encodeURIComponent(name) : "";

  //   const res = await get(
  //     `${process.env.REACT_APP_ADMIN}/odata/Cms?includeDeleted=false&api-version=Cms&$count=true${
  //       name ? `&$filter=contains(tolower(Title), tolower('${sanitizedName}'))` : ""
  //     }&$orderby=Title asc`
  //   );
  const res = await get(
    `${process.env.REACT_APP_ADMIN}/odata/Cms?includeDeleted=false&$filter=contains(tolower(Title), tolower('${sanitizedName}'))`
  );

  return res.value;
};

export const publishCms = async (data: ICmsItem) =>
  await post(`${process.env.REACT_APP_ADMIN}/Cms/Save`, JSON.stringify(data), "application/json");
